function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { GroupSubmenu } from './GroupSubmenu';
import { ScrollBarContainer } from '../../atoms/ScrollBarContainer/ScrollBarContainer';
import { IarrowRight2 } from '../../atoms/AgroIcon/icons';
import { AgroSpinner } from '../../atoms/AgroSpinner';
import { Text } from '../../atoms/Text';
import { Istore } from '../../atoms/AgroIcon/icons';
var DesktopMenu = withCssProps(function (_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    isLoading = _ref.isLoading,
    onlineStores = _ref.onlineStores,
    onlineStoresLink = _ref.onlineStoresLink,
    onlineStoresLogo = _ref.onlineStoresLogo,
    tagManager = _ref.tagManager;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    submenuContainer = _useState2[0],
    setSubmenuContainer = _useState2[1];
  var handleLinkClick = function handleLinkClick(e) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'menuHeader',
          category: e
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  function showSubmenu(item) {
    var showMoreText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var showMoreLink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#';
    if (item.Children && item.Children.length > 0) {
      setSubmenuContainer( /*#__PURE__*/React.createElement(MenuSubitemsContainer, null, /*#__PURE__*/React.createElement(SubmenuHeader, null, /*#__PURE__*/React.createElement(Text, {
        type: "heading-xs"
      }, item.Name), showMoreText ? /*#__PURE__*/React.createElement(LinkHeader, null, /*#__PURE__*/React.createElement(LinksMore, {
        title: showMoreText,
        tag: "a",
        type: "label-md",
        color: "blue600",
        href: showMoreLink
      }, showMoreText), ' ', /*#__PURE__*/React.createElement(IarrowRight2, {
        height: "16px",
        width: "16px",
        fill: "blue600"
      })) : null), /*#__PURE__*/React.createElement(Separate, null), /*#__PURE__*/React.createElement(SubmenuItems, null, item.Children.map(function (group, i) {
        return /*#__PURE__*/React.createElement(GroupSubmenu, {
          key: i,
          name: group.Name,
          link: group.URL,
          subitems: group.Children,
          mainCategory: item.Name,
          tagManager: tagManager,
          onMouseDown: function onMouseDown() {
            return handleLinkClick("".concat(group.Name, "_").concat(group.Children.Name));
          }
        });
      }))));
    } else {
      setSubmenuContainer('');
    }
  }
  return isOpen ? /*#__PURE__*/React.createElement(MenuContainer, null, /*#__PURE__*/React.createElement(MenuItemsContainer, null, /*#__PURE__*/React.createElement(MenuItems, {
    as: "ul",
    isLoading: isLoading
  }, isLoading ? /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(AgroSpinner, {
    size: "48px"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement(Item, {
      idx: index,
      href: item.URL,
      onMouseEnter: function onMouseEnter() {
        return showSubmenu(item, item.LinkText, item.URL);
      },
      onMouseDown: function onMouseDown() {
        return handleLinkClick("".concat(item.Name));
      }
    }, item.Name, item.Children && item.Children.length > 0 ? /*#__PURE__*/React.createElement("span", {
      className: 'arrow'
    }) : ''));
  }))), /*#__PURE__*/React.createElement(MenuBottom, null, !isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Separate, {
    separateStores: true
  }), /*#__PURE__*/React.createElement(Item, {
    href: onlineStoresLink,
    onlineStores: true
  }, /*#__PURE__*/React.createElement(Istore, {
    width: "16px",
    height: "16px",
    fill: "gray8"
  }), onlineStores)) : null)), submenuContainer) : null;
});
DesktopMenu.propTypes = {
  items: PropTypes.array,
  isOpen: PropTypes.bool,
  onlineStores: PropTypes.string,
  onlineStoresLink: PropTypes.string,
  onlineStoresLogo: PropTypes.string
};
DesktopMenu.displayName = 'DesktopMenu';
export { DesktopMenu };
var MenuContainer = styled.div.withConfig({
  displayName: "DesktopMenu__MenuContainer",
  componentId: "sc-19abw4w-0"
})(["display:flex;align-content:flex-start;height:calc(100vh - 140px);max-width:1400px;@media (max-width:", "){display:none;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint.lg;
});
var MenuItemsContainer = styled.div.withConfig({
  displayName: "DesktopMenu__MenuItemsContainer",
  componentId: "sc-19abw4w-1"
})(["box-shadow:1px 4px 11px 0 rgba(0,0,0,0.35);display:flex;flex-direction:column;justify-content:space-between;width:342px;margin-left:56px;margin-top:8px;"]);
var MenuItems = styled(ScrollBarContainer).withConfig({
  displayName: "DesktopMenu__MenuItems",
  componentId: "sc-19abw4w-2"
})(["background-color:", ";height:100%;margin:0;overflow-y:auto;overflow-x:hidden;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;padding:0;position:relative;border-radius:16px 16px 0 0;justify-content:space-between;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var isLoading = _ref4.isLoading;
  return isLoading && css(["border-radius:16px;"]);
});
var Item = styled.a.withConfig({
  displayName: "DesktopMenu__Item",
  componentId: "sc-19abw4w-3"
})(["color:", ";display:flex;justify-content:space-between;font-family:Montserrat;font-size:14px;letter-spacing:-0.2px;font-weight:500;height:44px;line-height:45px;list-style:none;padding:0 0 0 16px;position:relative;text-decoration:none;", ";", ";:hover{color:", ";background-color:", ";span:after{border-top:2px solid ", ";border-left:2px solid ", ";}}span:after{position:absolute;width:6px;height:6px;border-top:2px solid ", ";border-left:2px solid ", ";color:transparent;content:'';transform:rotate(135deg);margin-left:10px;margin-top:3px;transition:0.2s ease;top:15px;right:16px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray800;
}, function (_ref6) {
  var idx = _ref6.idx;
  return idx === 0 && css(["margin-top:16px;"]);
}, function (_ref7) {
  var onlineStores = _ref7.onlineStores;
  return onlineStores && css(["align-items:center;justify-content:flex-start;border-radius:0 0 16px 16px;svg{margin-right:16px;}"]);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.blue600;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.gray1;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.blue600;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.blue600;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.gray700;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.gray700;
});
var MenuSubitemsContainer = styled.div.withConfig({
  displayName: "DesktopMenu__MenuSubitemsContainer",
  componentId: "sc-19abw4w-4"
})(["background-color:", ";margin-left:10px;margin-top:8px;display:flex;flex-direction:column;justify-content:space-between;width:calc(100vw - 500px);max-width:1000px;min-width:768px;height:max-content;max-height:calc(100vh - 155px);border-radius:16px;"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.white;
});
var SubmenuItems = styled(ScrollBarContainer).withConfig({
  displayName: "DesktopMenu__SubmenuItems",
  componentId: "sc-19abw4w-5"
})(["align-content:start;box-sizing:border-box;display:flex;flex-wrap:wrap;padding:0px 30px;overflow-x:hidden;::-webkit-scrollbar{width:16px;background-color:transparent;}::-webkit-scrollbar-track{border:none;background-color:transparent;}::-webkit-scrollbar-thumb{height:84px;border:6px solid transparent;border-radius:100px;background-color:", ";background-clip:content-box;}::-webkit-scrollbar-thumb:hover{height:84px;border:6px solid transparent;border-radius:100px;background:", ";background-clip:content-box;}"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.gray600;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.gray700;
});
var MenuBottom = styled.div.withConfig({
  displayName: "DesktopMenu__MenuBottom",
  componentId: "sc-19abw4w-6"
})(["background-color:", ";border-radius:0 0 16px 16px;margin-bottom:8px;"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.white;
});
var LinksMore = styled(Text).withConfig({
  displayName: "DesktopMenu__LinksMore",
  componentId: "sc-19abw4w-7"
})(["letter-spacing:-0.2px;margin-right:4px;text-decoration:none;"]);
var SpinnerContainer = styled.div.withConfig({
  displayName: "DesktopMenu__SpinnerContainer",
  componentId: "sc-19abw4w-8"
})(["position:absolute;top:50%;left:45%;"]);
var SubmenuHeader = styled.div.withConfig({
  displayName: "DesktopMenu__SubmenuHeader",
  componentId: "sc-19abw4w-9"
})(["display:flex;justify-content:space-between;margin:24px 32px;gap:16px;"]);
var LinkHeader = styled.div.withConfig({
  displayName: "DesktopMenu__LinkHeader",
  componentId: "sc-19abw4w-10"
})(["display:flex;align-items:center;"]);
var Separate = styled.div.withConfig({
  displayName: "DesktopMenu__Separate",
  componentId: "sc-19abw4w-11"
})(["border-top:1px solid ", ";margin:0px 32px 24px 32px;", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.gray5;
}, function (_ref19) {
  var separateStores = _ref19.separateStores;
  return separateStores && css(["margin:0px;"]);
});